// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"37e458f4","479":"b89681be","568":"f7129bf9","753":"24190813","765":"cd6505d4","931":"af478ff9"}[chunkId] + ".chunk.js";
};